/**
 * Custom hook to determine if the current environment is development.
 * @function useIsDev
 * @returns {object} An object containing a boolean indicating if the environment is development.
 */
export const useIsDev = () => {
  const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production';

  return {
    isDev: !isProduction,
  };
};
